import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const MeetingBanner = ({ provider, joinUrl, onJoin }) => {
    const { t } = useTranslation('chat');

    const providerName = useMemo(() => {
        switch (provider) {
            case 'webex':
                return 'Webex';

            case 'zoom':
                return 'Zoom';

            case 'google':
                return 'Google';

            case 'microsoft':
                return 'Microsoft';
        }
    }, [provider]);

    if (!joinUrl) {
        return null;
    }

    return (
        <div className="discussion-zoom-banner">
            { t('ongoingMeeting', { provider: providerName }) }

            <button className="btn btn-secondary btn-small" onClick={onJoin}>{ t('Join Meeting') }</button>
        </div>
    )
}

export default MeetingBanner

